(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["royal-routine-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById('RoyalRoutinePopup');
    if (!root) return;

    const redirectUrl = 'https://www.roglabsai.com';
    const path = window.location.pathname;
    const blockedPath = path === '/cart' || path.startsWith('/checkouts') || path.startsWith('/account');
    const success = root.querySelector('[data-popup-success]');
    const errors = root.querySelector('[data-popup-errors]');
    const dismissKey = 'royalRoutinePopupDismissedUntil';
    const subscribedKey = 'royalRoutinePopupSubscribed';
    let opened = false;

    if (success) {
      localStorage.setItem(subscribedKey, 'true');
      window.location.assign(redirectUrl);
      return;
    }

    if (blockedPath || localStorage.getItem(subscribedKey) === 'true') return;

    const dismissedUntil = Number(localStorage.getItem(dismissKey) || 0);
    if (dismissedUntil > Date.now() && !errors) return;

    const openPopup = () => {
      if (opened) return;
      opened = true;
      root.hidden = false;
      requestAnimationFrame(() => root.classList.add('is-open'));
      window.setTimeout(() => root.querySelector('input[type="email"]')?.focus(), 280);
    };

    const closePopup = () => {
      root.classList.remove('is-open');
      const dismissDays = Number(root.dataset.dismissDays || 7);
      localStorage.setItem(dismissKey, String(Date.now() + dismissDays * 86400000));
      window.setTimeout(() => {
        root.hidden = true;
      }, 260);
    };

    root.querySelectorAll('[data-popup-close]').forEach((button) => {
      button.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !root.hidden) closePopup();
    });

    if (errors) {
      openPopup();
      return;
    }

    const delay = Number(root.dataset.delay || 10000);
    window.setTimeout(openPopup, delay);

    const handleScroll = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable > 0 && window.scrollY / scrollable >= 0.35) {
        openPopup();
        window.removeEventListener('scroll', handleScroll);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
